import React, { useEffect, useState } from "react";
import { CheckCircle } from "lucide-react";

// Shown after the Technology Check results are submitted (via Submit or Save & Exit).
// The parent controls how long it stays open before navigating away.
export const TechCheckSubmittedModal: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        document.body.style.overflow = "hidden";
        const t = setTimeout(() => setIsVisible(true), 60);
        return () => {
            document.body.style.overflow = "unset";
            clearTimeout(t);
        };
    }, []);

    return (
        <div
            className={`fixed inset-0 z-50 flex items-center justify-center p-4 transition-all duration-300 ${
                isVisible ? "bg-black/60 backdrop-blur-sm" : "bg-black/0"
            }`}
            role="dialog"
            aria-modal="true"
            aria-labelledby="tech-check-submitted-title"
            aria-describedby="tech-check-submitted-desc"
        >
            <div
                className={`relative w-full max-w-md overflow-hidden rounded-2xl bg-gradient-to-b from-[#dbeeff] to-white p-8 shadow-2xl transform transition-all duration-300 ${
                    isVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-2 scale-[.98]"
                }`}
            >
                <CheckCircle className="mx-auto h-10 w-10 text-green-600" />
                <h2
                    id="tech-check-submitted-title"
                    className="mt-4 text-center font-[Inter] text-[20px] font-bold text-(--ecpi-black-hex)"
                >
                    Test Results Submitted
                </h2>
                <div id="tech-check-submitted-desc" className="mt-4 text-center font-sora text-[13px] text-gray-700" aria-live="polite">
                    <p>Your technology check results have been submitted. Returning you to the dashboard...</p>
                </div>
            </div>
        </div>
    );
};

export default TechCheckSubmittedModal;
